import global from './global'
import meta from './meta'
import authorization from './authorization'
import publicPages from './publicPages'
import orders from './orders'

const en = {
    ...global.en,
    ...meta.en,
    ...authorization.en,
    ...publicPages.en,
    ...orders.en,
    test: 'test'
}

const lt = {
    ...global.lt,
    ...meta.lt,
    ...authorization.lt,
    ...publicPages.lt,
    ...orders.lt,
    test: 'test lt'
}

export default {en, lt}



// WEBPACK FOOTER //
// ./src/i18n/translations.js